<template>
  <div class="logo_wrap">
    <router-link
      :to="this.$store.getters.lang ? '/' + this.$store.getters.lang : '/'"
      active-class=""
      title="AppTown"
      class="logo"
    >
      <span class="logo_text_wrap">
        <span class="title">AppTown</span>
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HeaderLogo',
  data() {
    return {
      lang: '',
    }
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
@media only screen and (max-width: 360px) {
  .logo_wrap {
    font-size: 21px;
  }
  .logo_wrap .logo_text_wrap .title {
    font-size: 30px;
  }
}
</style>
